var common = require('./common.js')
function norm (v) {
	if (Array.isArray(v)) {
		let arr = []
		for (let s of v) {
			arr.push(s.trim().toLowerCase())
		}
		return arr
	}
	return v.trim().toLowerCase()
}

function getDomainFromUrl (url) {
	let match = url.match(
		/^(http|https|ftp)?(?:[\:\/]*)([a-z0-9\.-]*)(?:\:([0-9]+))?(\/[^?#]*)?(?:\?([^#]*))?(?:#(.*))?$/i,
	)
	return match[2] || ''
}

const socials = [
	'facebook.com',
	'youtube.com',
	'twitter.com',
	't.co',
	'instagram.com',
	'linkedin.com',
	'reddit.com',
	'vk.com',
	'tumblr.com',
	'pinterest.com',
	'meetup.com',
	'flickr.com',
	'ask.fm',
	'livejournal.com',
	'myspace.com',
]

// list of known seach engine, taken from
// https://support.google.com/analytics/answer/2795821?hl=en
const searchEngines = [
	`360.cn`,
	`alice.com`,
	`aliceadsl.fr`,
	`alltheweb.com`,
	`altavista.com`,
	`aol.com`,
	`ask.com`,
	`search.aol.fr`,
	`alicesuche.aol.de`,
	`search.auone.jp`,
	`isearch.avg.com`,
	`search.babylon.com`,
	`baidu.com`,
	`biglobe.ne.jp`,
	`bing.com`,
	`search.centrum.cz`,
	`search.comcast.net`,
	`search.conduit.com`,
	`cnn.com`,
	`daum.net`,
	`ekolay.net`,
	`eniro.se`,
	`globo.com/busca`,
	`go.mail.ru`,
	`google.com`,
	`goo.ne`,
	`haosou.com`,
	`search.incredimail.com`,
	`kvasir.no`,
	`bing.com`,
	`lycos.com`,
	`search.lycos.de`,
	`mamma.com`,
	`msn.com`,
	`money.msn.com`,
	`local.msn.com`,
	`mynet.com`,
	`najdi.si`,
	`naver.com`,
	`search.netscape.com`,
	`szukaj.onet.pl`,
	`ozu.es`,
	`rakuten.co.jp`,
	`rambler.ru`,
	`search-results.com`,
	`search.smt.docomo.ne.jp`,
	`sesam.no`,
	`seznam.cz`,
	`so.com`,
	`sogou.com`,
	`szukacz.pl`,
	`buscador.terra.com.br`,
	`search.tut.by`,
	`search.ukr.net`,
	`search.virgilio.it`,
	`voila.fr`,
	`wp.pl`,
	`yahoo.com`,
	`yahoo.cn`,
	`yahoo.com`,
	`m.yahoo.com`,
	`yandex.com`,
	`yandex.ru`,
	`yam.com`,
	`coccoc.com`,
]

let socialM = {}
let searchEngineM = {}

socials.forEach(s => {
	socialM[s + '.'] = true
})

searchEngines.forEach(se => {
	searchEngineM[se + '.'] = true
})

function getSourceFromRef (gclid, referrer) {
	if (gclid !== '') return 'advertising'
	let domain = getDomainFromUrl(referrer)
	if (domain === '') return 'direct'
	if (domain.startsWith('www.')) domain = domain.slice(4)
	if (!domain.endsWith('.')) domain += '.'

	// remove country
	// remove .com.**.
	if (domain.length > 9) {
		let com = domain.substring(domain.length - 8, domain.length - 3)
		if (com === '.com.' || com === '.net.') {
			domain = domain.substring(0, domain.length - 3)
		}
	}

	if (searchEngineM[domain]) return 'organic'
	if (socialM[domain]) return 'social'

	return 'referring'
}

// params: left operand type, left operand value, operator, right operand value
function evaluate (type, lval, op, rval) {
	if (type === 'bool') {
		if (op === 'eq') return lval === rval
		if (op === 'ne') return lval !== rval
	}
	if (type === 'string') {
		rval = rval || ''
		if (op === 'regex') op = 'con'

		lval = norm(lval)
		rval = norm(rval)
		if (op === 'eq') return lval === rval
		if (op === 'ne') return lval !== rval
		if (op === 'contains' || op === 'con') return lval.includes(rval)
		if (op === 'notContains' || op === 'notCon') return !lval.includes(rval)
		if (op === 'in') return rval.includes(lval)
	}

	if (type === 'number') {
		if (op === 'gt') return lval > rval
		if (op === 'gte') return lval >= rval
		if (op === 'lt') return lval < rval
		if (op === 'lte') return lval <= rval
		if (op === 'eq') return lval === rval
		if (op === 'ne') return lval !== rval
		if (op === 'inRange') return lval >= rval[0] && lval <= rval[1]
		if (op === 'notInRange') return lval < rval[0] || lval > rval[1]
	}

	return false
}

// callback when user is about to leave site
function trackExitIntent (cb) {
	let fired = false
	const handleMouseleave = e => {
		if (fired) return
		if (e.clientY > 10) return // not move to top
		fired = true
		if (cb) cb()
		document.removeEventListener('mouseleave', handleMouseleave, false)
	}

	document.addEventListener('mouseleave', e => handleMouseleave(e), false)
}

// callback after user has scrolled X% down on the current page
function trackScrollingPercentage (percent, cb) {
	let fired = false
	let handleScroll = e => {
		if (fired) return

		let scrollTop = e.srcElement.scrollingElement ? e.srcElement.scrollingElement.scrollTop : e.srcElement.scrollTop
		let scrollHeight = e.srcElement.scrollingElement
			? e.srcElement.scrollingElement.scrollHeight
			: e.srcElement.scrollHeight

		if (scrollTop > 0 && scrollHeight > 0 && scrollTop / scrollHeight >= percent) {
			fired = true
			if (cb) cb()
			window.removeEventListener('scroll', handleScroll, false)
		}
	}

	window.addEventListener('scroll', handleScroll, false)
}

// callback when user clicks on a specific part of page
function trackAreaClicked (selector, cb) {
	selector = selector || ''
	common.map(selector.split(','), selector => {
		let dom = document.querySelector(selector)
		if (!dom) return

		let fired = false
		let handleClick = () => {
			if (fired) return
			fired = true
			if (cb) cb()
			dom.removeEventListener('click', handleClick, false)
		}

		dom.addEventListener('click', handleClick, false)
	})
}

// callback when user has stopped all activity (clicking, scrolling, ...)
function trackInactivity (seconds, cb) {
	let events = [
		'scroll',
		'keyup',
		'keydown',
		'mousemove',
		'mousewheel',
		'mouseenter',
		'mouseover',
		'mousedown',
		'touchstart',
		'touchmove',
		'touchenter',
	]
	let inactiveSeconds = 0
	let resetTime = () => {
		inactiveSeconds = 0
	}
	let fired = false
	let timer = setInterval(() => {
		if (fired) return
		inactiveSeconds++
		if (inactiveSeconds < seconds) return

		fired = true
		clearInterval(timer)
		if (cb) cb()
		for (let ev of events) {
			document.removeEventListener(ev, resetTime, false)
		}
	}, 1000)

	for (let ev of events) {
		document.addEventListener(ev, resetTime, false)
	}
}

let timeOnPage = 0 // seconds
setInterval(() => {
	timeOnPage++
}, 1000)

// when user has been on the page for at least X seconds
function trackTimeOnPage (seconds, cb) {
	let fired = false
	let timer = setInterval(() => {
		if (fired) return
		if (timeOnPage < seconds) return
		fired = true
		if (cb) cb()
		clearInterval(timer)
	}, 1000)
}

module.exports = {
	getSourceFromRef,
	evaluate,
	trackExitIntent,
	trackScrollingPercentage,
	trackAreaClicked,
	trackInactivity,
	trackTimeOnPage,
	norm,
}
